import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  IL_COLORS,
  formatCurrency,
  formatSignedPercent,
} from "../../../../constants/investmentLeague";

const ArrowUpIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);

const ArrowDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <polyline points="19 12 12 19 5 12" />
  </svg>
);

const CalloutBox = ({ type, holding, t }) => {
  const isBest   = type === "best";
  const color    = isBest ? IL_COLORS.positive : IL_COLORS.negative;
  const bg       = isBest ? IL_COLORS.positiveBg : IL_COLORS.negativeBg;
  const label    = isBest ? "Best Performer" : "Worst Performer";
  const Icon     = isBest ? ArrowUpIcon : ArrowDownIcon;

  return (
    <Box
      sx={{
        background:   bg,
        border:       `1px solid ${color}33`,
        borderRadius: "10px",
        p:            2.5,
        display:      "flex",
        alignItems:   "center",
        gap:          2,
      }}
    >
      <Box
        sx={{
          width:          36,
          height:         36,
          borderRadius:   "50%",
          background:     color,
          color:          "#fff",
          display:        "flex",
          alignItems:     "center",
          justifyContent: "center",
          flexShrink:     0,
        }}
      >
        <Icon />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize:     "11px",
            fontWeight:   600,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color:        t.text3,
            mb:           0.5,
          }}
        >
          {label}: {holding.ticker} — {holding.name}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: t.text2 }}>
          {formatCurrency(holding.invested)} → {formatCurrency(holding.current)}
        </Typography>
      </Box>

      <Typography
        sx={{
          fontSize:   { xs: "18px", md: "22px" },
          fontWeight: 700,
          color,
          flexShrink: 0,
        }}
      >
        {formatSignedPercent(holding.returnsPct)}
      </Typography>
    </Box>
  );
};

const PerformanceCallouts = ({ best }) => {
  const theme = useTheme();
  const t     = theme.custom;

  if (!best) return null;

  return (
    <Box
      sx={{
        background:   t.surface,
        border:       `1px solid ${t.border2}`,
        borderRadius: "10px",
        p:            { xs: 2, md: 3 },
        display:      "flex",
        flexDirection: "column",
        gap:          2,
        height:       "100%",
      }}
    >
      <Typography sx={{ fontSize: "15px", fontWeight: 600, color: t.text }}>
        Performance Callouts
      </Typography>

      <CalloutBox type="best" holding={best} t={t} />
    </Box>
  );
};

export default PerformanceCallouts;
